export const MOBILE_MONEY_PROVIDERS = [
    { name: "MTN Mobile Money", _id: "MTN" },
    { name: "Airtel Money", _id: "AIRTEL" },
];

export const BANK_OPTIONS = [
    { name: "Stanbic Bank", _id: "stanbic" },
    { name: "Equity Bank", _id: "equity" },
    { name: "DFCU Bank", _id: "dfcu" },
    { name: "Centenary Bank", _id: "centenary" },
];

export const NOTIFICATION_TYPES = {
    SCHEDULED: "SCHEDULED",
    RESEND: "RESEND",
};  

// INFO: User Roles
export const roles = {
  USER: "USER",
  TASKER: "TASKER",
};

export const unitStatus = {
    VACANT: "VACANT",
    OCCUPIED: "OCCUPIED",
};

export const monthArray = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

export const cities = [
    { label: "Kampala", value: "Kampala" },
    { label: "Entebbe", value: "Entebbe" },
    { label: "Jinja", value: "Jinja" },
    { label: "Gulu", value: "Gulu" },
    { label: "Mbale", value: "Mbale" },
    { label: "Mbarara", value: "Mbarara" },
    { label: "Mukono", value: "Mukono" },
    { label: "Arua", value: "Arua" },
    { label: "Masaka", value: "Masaka" }
];

export const areas = [
    {
      city: "Kampala",
      area: ["Kololo", "Naguru", "Bugolobi", "Ntinda", "Makindye"]
    },
    {
      city: "Entebbe",
      area: ["Kitoro", "Katabi", "Bugonga"]
    },
    {
      city: "Jinja",
      area: ["Walukuba", "Nile Crescent", "Masese"]
    },
    {
      city: "Gulu",
      area: ["Layibi", "Pece", "Laroo"]
    },
    {
      city: "Mbale",
      area: ["Namatala", "Senior Quarters", "Namakwekwe"]
    },
    {
      city: "Mbarara",
      area: ["Kakoba", "Kamukuzi", "Nyamitanga"]
    },
    {
      city: "Mukono",
      area: ["Seeta", "Nasuuti", "Kyetume"]
    },
    {
      city: "Arua",
      area: ["Awindiri", "Pajulu", "Dadamu"]
    },
    {
      city: "Masaka",
      area: ["Nyendo", "Kimaanya", "Kirumba"]
    }
];

export const FORM_MODES = {
    VIEW: "view",
    EDIT: "edit",
    ADD: "add",
};

export const supportRequestTypes = {
  LEGAL: "LEGAL",
  MAINTENANCE: "MAINTENANCE",
  TAX_CONSULT: "TAX_CONSULT",
}
export const firebaseMasterFolder = {
  F_LANDLOD: "landlod",
}

export const firebaseUplaodFolders = {
  F_ID_IMAGES: "idimages",
  F_PROFILE_PICTURES: "profilepictures",
  F_REFERENCES: "references",  
  F_TENANT: "tenant",
}

export const maximumImagesUploadingSizes = {
  size_300KB : 0.3, // 300KB
  size_450KB : 0.45, // 300KB
  size_1MB : 1 // 300KB
}

export const COUNTRY_CODES = [
   { code: "+256", country: "Uganda", flag: "🇺🇬" },
]

